import React from "react";
import classes from "./Spinner.module.css";
import { Spin, Skeleton } from "antd";

const LoadingCanvas = props => {
  
  return <Spin size="large" style={{ "position": "absolute", "left": "50%", "top": "50%" }} />;
};
export default LoadingCanvas;